// extracted by mini-css-extract-plugin
module.exports = {"--space-1x":"8px","space1X":"8px","root":"root-2SLy5I38BT"};